
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close @close="getCancelar">
        <template #header>
          <h4 class="not-margin">
            Crear Detalle Componente Académico
          </h4>
        </template>


        <div class="con-form">
        <vs-row>
            <vs-col sm="12" lg="4">
                <label for="nombre"  class="labelInput">Nombre</label>
                <vs-input class="pt-0" id="nombre" placeholder="Escriba el nombre" v-model="nombre">
                    <template #message-danger v-if="errorFields.includes('nombre')">
                        Requerido
                    </template>
                </vs-input>
            </vs-col>
            <vs-col sm="12" lg="4">
                <label for="seleccion"  class="labelInput">Tipo</label>
                <vs-select class="pt-0" placeholder="Seleccionar" v-model="tipo">
                    <template #message-danger v-if="errorFields.includes('tipo')">
                        Requerido
                    </template>
                    <vs-option label="Entrada" value="entrada">
                        Entrada
                    </vs-option>
                    <vs-option label="Calculado" value="calculado">
                        Calculado
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="4">
                <label for="ponderacion"  class="labelInput">Orden</label>
                <vs-input type="number" class="pt-0" id="ponderacion" placeholder="Escriba la ponderación" v-model="ponderacion">
                </vs-input>
            </vs-col>
            <vs-col sm="12" lg="12" class="text-center my-2 text-uppercase" v-if="tipo === 'calculado'">
                <md-divider></md-divider>
                <h6 class="mt-3">Configuración de lógica a aplicar</h6>
            </vs-col>
            <vs-col sm="12" lg="4" v-if="tipo === 'calculado'">
                <label for="detalles_componentes"  class="labelInput">Tipo de calculo</label>
                <vs-select class="pt-0" placeholder="Tipo de calculo" v-model="tipo_calculo" filter>
                    <template #message-danger v-if="errorFields.includes('tipo_calculo')">
                        Requerido
                    </template>
                    <vs-option label="Promedio" value="promedio">
                        Promedio
                    </vs-option>
                    <vs-option label="Promediar con validación" value="validacion">
                        Promediar con validación
                    </vs-option>
                    <vs-option label="Tomar calificación acreditable" value="calificacion_acreditable">
                        Tomar calificación acreditable
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="8" v-if="tipo === 'calculado' && tipo_calculo != 'validacion' && row.detalle_componente[0]">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="grupo" class="labelInput">
                        Periodo aplicar calculos
                    </label>
                    <div class="d-flex" v-if="row.detalle_componente[0]">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(row.detalle_componente, 'periodo')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('periodo')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <vs-select class="pt-0" placeholder="Periodo aplicar calculos" v-model="detalles_componentes" filter multiple collapse-chips>
                    <template #message-danger v-if="errorFields.includes('detalles_componentes')">
                        Requerido
                    </template>
                    <vs-option v-for="option in row.detalle_componente" :key="option.id"  :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col w="12" v-if="tipo === 'calculado' && tipo_calculo == 'validacion'">
                <p><strong>En caso de que el periodo anterior no sea acreditable se buscará que se promedien dos periodos, pero condicionado a la aprobación de uno de ellos. En caso de que se apruebe el validado se promedian, en caso contrario se toma la calificación mínima reprobatoria para mostrar en boleta.</strong></p>
            </vs-col>
            <vs-col sm="12" lg="12" v-if="tipo === 'calculado' && tipo_calculo === 'validacion' && row.detalle_componente[0]">
                <label for="detalles_componentes"  class="labelInput">¿Qué periodo deseas que sea el validado?</label>
                <vs-select filter class="pt-0" placeholder="Periodos" v-model="periodo_a_validar_para_obtener_calificacion_id">
                    <vs-option v-for="option in row.detalle_componente" :key="option.id"  :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="6" v-if="tipo === 'calculado' && tipo_calculo === 'validacion' && row.detalle_componente[0]">
                <label for="detalles_componentes"  class="labelInput">¿Con que periodo deseas promediar el validado?</label>
                <vs-select filter class="pt-0" placeholder="Periodos" v-model="periodo_a_validar_para_condicionar_calculo_id">
                    <vs-option v-for="option in row.detalle_componente" :key="option.id"  :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="6" v-if="tipo === 'calculado' && tipo_calculo === 'validacion'">
                <div class="d-flex"> 
                    <label for="Decimales a redondear"  class="labelInput">¿Qué promedio es el mínimo acreditable?</label>
                </div>
                <vs-input type="number" class="pt-0" id="Decimales a redondear" placeholder="Promedio mínimo acreditable a validar." v-model="promedio_acreditable_a_validar">
                </vs-input>
            </vs-col>
            <vs-col sm="12" lg="12" class="text-center my-2 text-uppercase" v-if="tipo === 'calculado'">
                <md-divider></md-divider>
                <h6 class="mt-3">Configuración de formato</h6>
            </vs-col>
            <vs-col sm="12" lg="6" v-if="tipo === 'calculado'">
                <label for="seleccion"  class="labelInput">Tipo de formato</label>
                <vs-select class="pt-0" placeholder="Seleccionar" v-model="tipo_configuracion_formato">
                    <template #message-danger v-if="errorFields.includes('tipo_configuracion_formato')">
                        Requerido
                    </template>
                    <vs-option label="Truncado" value="truncado">
                        Truncado
                    </vs-option>
                    <vs-option label="Redondeado" value="redondeado">
                        Redondeado
                    </vs-option>
                </vs-select>
            </vs-col>
            <template v-if="tipo_configuracion_formato == 'truncado'">
                <vs-col sm="12" lg="6" v-if="tipo === 'calculado'">
                    <label for="Decimales a truncar"  class="labelInput">Decimales a truncar</label>
                    <vs-input :disabled="disabledRow('truncar')" type="number" class="pt-0" id="Decimales a truncar" placeholder="Escriba la ponderación" v-model="decimales_truncar">
                    <template #message-danger v-if="errorFields.includes('decimales_truncar')">
                        Requerido
                    </template>
                    </vs-input>
                </vs-col>
            </template>
            <template v-if="tipo_configuracion_formato == 'redondeado'">
                <vs-col sm="12" lg="6" v-if="tipo === 'calculado'">
                    <label for="Decimales a redondear"  class="labelInput">Decimales a redondear</label>
                    <vs-input :disabled="disabledRow('redondear')" type="number" class="pt-0" id="Decimales a redondear" placeholder="Escriba la ponderación" v-model="decimales_redondear">
                    <template #message-danger v-if="errorFields.includes('decimales_redondear')">
                        Requerido
                    </template>
                    </vs-input>
                </vs-col>
            </template>
            <vs-col sm="12" lg="6" v-if="tipo === 'calculado'">
                <div class="d-flex"> 
                    <label for="Decimales a redondear"  class="labelInput">Calificación mínima reprobatoria a mostrar en boleta</label>
                </div>
                <vs-input type="number" class="pt-0" id="Decimales a redondear" placeholder="Calificación mínima reprobatoria a mostrar en boleta" v-model="calificacion_minima_reprobatoria">
                    <template #message-danger v-if="errorFields.includes('calificacion_minima_reprobatoria')">
                        Requerido
                    </template>
                </vs-input>
            </vs-col>
            <vs-col sm="12" lg="6" v-if="tipo === 'calculado'">
                <div class="d-flex"> 
                    <label for="Decimales a redondear"  class="labelInput">Promedio mínimo acreditable.</label>
                </div>
                <vs-input type="number" class="pt-0" id="Decimales a redondear" placeholder="Promedio mínimo acreditable." v-model="promedio_acreditable">
                </vs-input>
            </vs-col>
            <vs-col sm="12" lg="12" v-if="tipo === 'calculado' && row.detalle_componente[0]">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="detalles_componentes"  class="labelInput">Periodos a ocultar si se logra el Promedio mínimo acreditable.</label>
                    <div class="d-flex" v-if="row.detalle_componente[0]">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(row.detalle_componente, 'periodos_a_ocultar')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('periodos_a_ocultar')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <vs-select class="pt-0" placeholder="Periodos a ocultar si se logra el promedio mínimo a acreditar" v-model="periodos_a_ocultar" filter multiple collapse-chips>
                    <vs-option v-for="option in row.detalle_componente" :key="option.id"  :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                    </vs-option>
                </vs-select>
            </vs-col>
        </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="getCancelar()">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getGuardarGeneral()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
    export default {
        props:[
        'value',
        'row',
        'general',
        'indice',
        'fila'
        ],
        data:() => ({
            active: false,
            nombre: '',
            tipo:'',
            ponderacion: '',
            detalles_componentes: '',
            decimales_truncar: '',
            decimales_redondear: '',
            continuar: false,
            errorFields:[],
            promedio_acreditable: '',
            periodos_a_ocultar: '',
            calificacion_minima_reprobatoria: '',
            tipo_calculo: '',
            periodo_final: '',
            periodo_final_adicional_id: '',
            periodo_a_validar_para_condicionar_calculo_id: '',
            periodo_a_validar_para_obtener_calificacion_id: '',
            promedio_acreditable_a_validar: '',
            tipo_configuracion_formato: ''
        }),
        methods:{
            disabledRow(tipo){
                if(tipo == 'truncar'){
                    if(this.decimales_redondear){
                        return true
                    }
                }
                if(tipo == 'redondear'){
                    if(this.decimales_truncar){
                        return true
                    }
                }
            },
            selectAll(seleccion, tipo){
                let arr = []
                seleccion.forEach(i => {
                arr.push(i.id)
                })
                if(tipo == 'periodo'){
                    this.detalles_componentes = arr
                }
                if(tipo == 'periodos_a_ocultar'){
                    this.periodos_a_ocultar = arr
                }
            },
            deseleccionarAll(tipo){
                if(tipo == 'periodo'){
                    this.detalles_componentes = ''
                }
                if(tipo == 'periodos_a_ocultar'){
                    this.periodos_a_ocultar = ''
                }
            },
            checkByType (type, val) {
                switch (type) {
                    case 'string':
                        if (val && val.constructor.name === 'String' && val.trim()) {
                            return true
                        }
                    case 'number':
                        if (val && val.constructor.name === 'Number' && val > 0) {
                            return true
                        } 
                }
                return false
            },
            sanityForm () {
                this.errorFields = []
                if (!this.checkByType ('string', this.nombre)) {
                    this.errorFields.push('nombre')
                }
                if (!this.checkByType ('string', this.tipo)) {
                    this.errorFields.push('tipo')
                }
                if(this.tipo === 'calculado'){
                    if(this.tipo_calculo != 'validacion'){
                        if (!this.detalles_componentes) {
                            this.errorFields.push('detalles_componentes')
                        }
                    }
                    if (!this.calificacion_minima_reprobatoria) {
                        this.errorFields.push('calificacion_minima_reprobatoria')
                    }
                    if (!this.tipo_calculo) {
                        this.errorFields.push('tipo_calculo')
                    }
                    if(!this.tipo_configuracion_formato){
                        this.errorFields.push('tipo_configuracion_formato')
                    }
                    if(this.tipo_configuracion_formato == 'truncado'){
                        if (!this.decimales_truncar) {
                            this.errorFields.push('decimales_truncar')
                        }
                    }
                    if(this.tipo_configuracion_formato == 'redondeado'){
                        if (!this.decimales_redondear) {
                            this.errorFields.push('decimales_redondear')
                        }
                    }
                }
                if (!this.errorFields.length){
                    return this.continuar = true
                } else {
                    return this.continuar = false
                }
            },
            async getGuardarGeneral(){
                this.sanityForm()
                if(this.continuar === true){
                    const loading = this.$vs.loading()
                    try{
                        const payload = {
                            "nombre": this.nombre,
                            "tipo": this.tipo,
                            "ponderacion": this.ponderacion,
                            "decimales_truncar": this.decimales_truncar,
                            "decimales_redondear": this.decimales_redondear,
                            "promedio_acreditable": this.promedio_acreditable,
                            "calificacion_minima_reprobatoria": this.calificacion_minima_reprobatoria,
                            "tipo_calculo": this.tipo_calculo == 'validacion' ? 'promedio_condicionado' : this.tipo_calculo,
                            "periodo_a_validar_para_condicionar_calculo_id": this.periodo_a_validar_para_condicionar_calculo_id,
                            "periodo_a_validar_para_obtener_calificacion_id": this.periodo_a_validar_para_obtener_calificacion_id,
                            "promedio_acreditable_a_validar": this.promedio_acreditable_a_validar,
                            "tipo_configuracion_formato": this.tipo_configuracion_formato,
                        };
                        if(this.detalles_componentes){
                            if(this.tipo_calculo == 'validacion'){
                                payload.detalles = [this.detalles_componentes]
                            }else{  
                                payload.detalles = this.detalles_componentes.filter(detalle => ![null, NaN, ''].includes(detalle))
                            }
                        }else{
                            payload.detalles = this.detalles_componentes
                        }
                        if(this.periodos_a_ocultar){
                            payload.periodos_a_ocultar = this.periodos_a_ocultar.filter(periodo => ![null, NaN, ''].includes(periodo))
                        }else{
                            payload.periodos_a_ocultar = this.periodos_a_ocultar
                        }
                        const response = await academico.getCrearGeneral(payload, this.row.id)
                        if(response.status === 200){
                            this.getCancelar()
                            this.active = false
                            this.$emit('refreshTable')
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'El componente fue creado con éxito.',
                            })
                        }
                        loading.close()
                    }catch(error){
                        console.log(error)
                        loading.close()
                    }
                }
            },
            getTipoInfo(){
                if(this.tipo === 'entrada'){
                    this.detalles_componentes = ''
                    this.decimales_truncar = ''
                    this.decimales_redondear = ''
                    this.promedio_acreditable = ''
                    this.promedio_acreditable_a_validar = ''
                    this.calificacion_minima_reprobatoria = ''
                    this.periodos_a_ocultar = ''
                    this.tipo_calculo = ''
                    this.periodo_final_adicional_id = ''
                    this.periodo_a_validar_para_condicionar_calculo_id = ''
                    this.periodo_a_validar_para_obtener_calificacion_id = ''
                    this.tipo_configuracion_formato = ''
                }
            },
            getCancelar(){
                this.nombre =  ''
                this.tipo = ''
                this.ponderacion =  ''
                this.detalles_componentes =  ''
                this.decimales_truncar =  ''
                this.decimales_redondear =  ''
                this.promedio_acreditable = ''
                this.promedio_acreditable_a_validar = ''
                this.calificacion_minima_reprobatoria = ''
                this.periodos_a_ocultar = ''
                this.tipo_calculo = ''
                this.periodo_a_validar_para_condicionar_calculo_id = ''
                this.periodo_a_validar_para_obtener_calificacion_id = ''
                this.periodo_final_adicional_id = ''
                this.tipo_configuracion_formato = ''
                this.active = false
            },
        },
        watch:{
            
            value (val) {
                this.active = val
            },       
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
            tipo(){
                this.getTipoInfo()
            },
            tipo_configuracion_formato(){
                if(this.tipo_configuracion_formato == 'truncado'){
                    this.decimales_redondear = ''
                }else{
                    this.decimales_truncar = ''
                }
            }
        }
    }
</script>
